import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M50 56q0-26 50-26t50 26v94q-50 20-100 0Z\"></path><path fill=\"var(--mc-avatar)\" d=\"M62 76h22v14H62zM116 76h22v14h-22z\"></path><path d=\"M65 79h6v8h-6zM125 79h6v8h-6z\"></path><path fill=\"none\" stroke=\"var(--mc-avatar)\" stroke-linejoin=\"bevel\" stroke-width=\"5\" d=\"m60 130 20-6 6 10 14-10 14 10 6-10 20 6\"></path><path stroke=\"var(--mc-avatar)\" stroke-width=\"3\" d=\"m70 44 14 6M120 50l14-6\"></path>", 5)
  ]))]))
}
export default { render: render }